import React from 'react';
import PropTypes from 'prop-types';

import Homepage from 'common/designer-modules/page-template';
import { useSelector } from 'react-redux';
import { siteInfoSelector } from 'admin/state/modules/common/selectors';
import { contentResourcesSelector } from 'admin/state/modules/site-designer/selectors';
import {
   fetchVideos,
   getPhotosets,
   initStoreData,
   getStories,
}  from 'admin/api/AuthApi';
const SiteDesignerRightSidePageTemplate = ({
   activeEditableSection,
   onClickSection,
   desktopType,
   pageSections,
   globalSettings,
}) => {
   const siteInfo = useSelector(siteInfoSelector);
   const contentResources = useSelector(contentResourcesSelector);

   return (
      <Homepage
         isPreview={ true }
         activeEditableSection={ activeEditableSection }
         onClickSection={ onClickSection }
         isMobile={ 'mobile' === desktopType }
         authUser={ {} }
         pageSections={ pageSections }
         globalSettings={ globalSettings }
         siteInfo={ siteInfo }
         resources={ contentResources }
         //apis
         fetchVideos={ fetchVideos }
         fetchPhotoset={ getPhotosets }
         initStoreData={ initStoreData }
         getStories={ getStories }
      />
   )
}

SiteDesignerRightSidePageTemplate.propTypes = {
   pageSections: PropTypes.object,
   activeEditableSection: PropTypes.string,
   onClickSection: PropTypes.func,
   desktopType: PropTypes.string,
   globalSettings: PropTypes.object,
}

export default SiteDesignerRightSidePageTemplate;
